import apiHelpers from './apiHelpers';

export default {
    getFeaturesData(data, body) {
        return apiHelpers.httpRequest(`stats/slice?features=${data.features.join(',')}&events=${data.events.join(',')}&sandbox=${data.sandbox}&start=${encodeURIComponent(data.filter.date.start)}&end=${encodeURIComponent(data.filter.date.end)}&cohort=${data.filter.date.cohort}${data.filter.additional}`, body, 'get');
    },
    getArppus(data, body) {
        return apiHelpers.httpRequest(`arppus?features=${data.features.join(',')}&events=${data.events.join(',')}&sandbox=${data.sandbox}&start=${encodeURIComponent(data.filter.date.start)}&end=${encodeURIComponent(data.filter.date.end)}&cohort=${data.filter.date.cohort}${data.filter.additional}`, body, 'get');
    },
    addArppus(bundleId, body) {
        return apiHelpers.httpRequest(`arppus/${bundleId}`, body, 'put');
    },
    getSubscriptionEvents(subscriptions, projects) {
        return apiHelpers.httpRequest(`stats/slice?features=bundle_id&events=${subscriptions.join(',')}&sandbox=false&start=${encodeURIComponent('2000-01-01T00:00:00+03:00')}&end=${encodeURIComponent('2050-01-01T00:00:00+03:00')}&cohort=false&equal:bundle_id=${projects.map(({bundle_id}) => bundle_id).join(',')}`, {}, 'get');
    },
    colorFeatureRows(data) {
        return apiHelpers.httpRequest(`stats/slice:mark`, data, 'post');
    },
};
